import { render, staticRenderFns } from "./students-access.vue?vue&type=template&id=e3a9f5c6&scoped=true&"
import script from "./students-access.vue?vue&type=script&lang=js&"
export * from "./students-access.vue?vue&type=script&lang=js&"
import style0 from "./students-access.vue?vue&type=style&index=0&id=e3a9f5c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a9f5c6",
  null
  
)

export default component.exports